import { h } from 'preact'
import { PureComponent } from 'preact/compat'

import styles from './App.module.css'
import { Heading } from './heading'
import { Section } from './section'
import { Footer } from './footer'
// types
import type { SectionType, BylineType } from './domain'

type AppProps = {
  data: {
    tittel: string
    inngang: string
    manus: Array<SectionType>
    byline: BylineType
  }
}

export class App extends PureComponent<AppProps> {
  render() {
    const { manus, tittel, inngang, byline } = this.props.data
    return (
      <div className={styles.app}>
        <article>
          <Heading tittel={tittel} ingress={inngang} byline={byline} />
          {manus.map((section, idx) => (
            <Section key={idx} section={section} />
          ))}
        </article>
        <Footer />
      </div>
    )
  }
}
